// Decode HTML entities in text.
//
// Done in ONE pass on purpose. The previous version chained .replace() calls
// and decoded &amp; BEFORE &lt;/&gt;, which double-unescapes: the input
// "&amp;lt;img src=x onerror=alert(1)&amp;gt;" — text deliberately escaped so
// it would DISPLAY as markup — came back out as
// "<img src=x onerror=alert(1)>". CodeQL flagged it as js/double-escaping.
// ReactMarkdown runs without rehypeRaw here, so that string renders as text
// rather than live HTML, but the corruption was real and one plugin away from
// being an injection. A single pass cannot re-scan its own output, so no
// ordering of these entities can reintroduce the bug.
const HTML_ENTITIES: Record<string, string> = {
	"&#x2F;": "/",
	"&#x27;": "'",
	"&quot;": '"',
	"&lt;": "<",
	"&gt;": ">",
	"&amp;": "&",
};

export function decodeHtmlEntities(text: string): string {
	return text.replace(
		/&(?:#x2F|#x27|quot|lt|gt|amp);/g,
		(entity) => HTML_ENTITIES[entity] ?? entity,
	);
}
